export default class RoutePinger {
    constructor(url, intervalMs = 25000) {
        this.url = url;
        this.intervalMs = intervalMs;
        this.timerId = null;
    }

    async ping() {
        try {
            const response = await fetch(this.url, { method: 'GET' });
            if (!response.ok) {
                console.warn(`Ping failed: ${response.status}`);
            }
        } catch (error) {
            console.error('Ping error:', error);
        }
    }

    start() {
        if (this.timerId) return; // already running
        this.timerId = setInterval(() => this.ping(), this.intervalMs);
    }

    stop() {
        if (this.timerId) {
            clearInterval(this.timerId);
            this.timerId = null;
        }
    }
}